import React, { useEffect } from 'react';
import {
    Container, Typography, Paper, Box, Alert
} from '@mui/material';
import UploadIcon from '@mui/icons-material/CloudUpload';
import { saveAs } from 'file-saver';
import ImportCSVForm from '../../components/import/ImportCSVForm';
import { authFetch } from '../../lib/authFetch';

const BulkUploadTransactionForm: React.FC = () => {
    useEffect(() => {
        document.title = 'Quick Upload | Velora Money';
    }, []);

const handleTemplateDownload = async (e: React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();

  try {
    const res = await authFetch('/api/ledger/import-template');
    if (!res.ok) {
      let message = 'Failed to download import template';
      try {
        const payload = await res.json();
        if (payload?.message) {
          message = payload.message;
        }
      } catch {
        // ignore JSON parse errors for non-JSON bodies
      }
      window.alert(message);
      return;
    }

    const blob = await res.blob();
    saveAs(blob, 'transaction-import-template.csv');
  } catch (error) {
    console.error('Failed to download import template', error);
    window.alert('Failed to download import template');
  }
};

return (
  <React.Fragment>
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box
        sx={{
          maxWidth: 960,
          mx: 'auto',
          alignItems: 'start',
        }}
      >
        <Paper
          elevation={2}
          sx={{
            p: { xs: 2, md: 3 },
            borderRadius: 3,
          }}
        >
          <Alert severity="info" sx={{ mb: 2 }}>
            Manual multi-row entry is not available yet. Use CSV import or add transactions one at a time from the Transactions page.
          </Alert>
          <Typography
            variant="h4"
            sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}
          >
            <UploadIcon /> Quick Upload:
          </Typography>

          <Typography
            variant="body1"
            sx={{ color: 'text.secondary', maxWidth: 1460, mb: 2, mt: 1 }}
          >
            <em>Short on time? Got a lot of transactions to add?</em>
            <br /><br />
            Bulk import your records using the ledger CSV flow.
            <br /><br />
            First, <a
              href="/api/ledger/import-template"
              onClick={handleTemplateDownload}
            >
              download our CSV Template.
            </a>
            <br /><br />
            The template uses ledger-native <code>kind</code> rows (income, expense, transfer, cardPurchase, cardPayment, adjustment) and account name columns for routing entries.
            <br /><br />
            Then upload your file below.
            <br /><br />
            <ImportCSVForm />
            <br /><br />
            Once the upload is complete (usually only takes a few moments), visit your <a
              href="/dashboard"
            >Dashboard</a> , <a
              href="/transactions"
            >Transactions Log</a> or <a
              href="/calendar"
            >MyCalendar</a> view to see your imported transactions.
          </Typography>
        </Paper>
      </Box>
    </Container>
  </React.Fragment>
);

};

export default BulkUploadTransactionForm;
